import React from 'react';
import { usePrefixTranslation } from '../../../i18n';
import { actions, useTypedDispatch, useTypedSelector } from '../../../redux';
import { DataDisplayCard } from '../cards/DataDisplayCard';

/**
 * Fetch schedule adherence information and render it using a data card.
 */
export const ScheduleAdherence = () => {
    const { t } = usePrefixTranslation('dashboard', { dashboard: 'metrics.ScheduleAdherence' });
    const dispatch = useTypedDispatch();
    const { scheduleAdherence } = useTypedSelector(state => ({ scheduleAdherence: state.stats.scheduleAdherence }));

    React.useEffect(() => void dispatch(actions.stats.scheduleAdherence()), []);

    return (
        <DataDisplayCard
            fetching={scheduleAdherence.fetching}
            color={['#38EF7D', '#11998E']}
            name={t('title')}
            main={t('projects-adherent', { count: (scheduleAdherence.stats?.ratio ?? 0) * 100 })}
            ratio={scheduleAdherence.stats?.ratio ?? 0.5}
        />
    );
};
